module.exports = __webpack_public_path__ + "assets/img/title-ad289903.png";